import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { FormActions } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={12}>
							<TermsDropdownList render='field' name='termId' label={t('TermHolidayPeriod_Name')} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'termHolidayPeriodsFilter' })(withTranslation()(Filter));